var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72967 18V0.800999H8.38517C9.67217 0.800999 10.7387 1.008 11.5847 1.422C12.4397 1.836 13.0787 2.385 13.5017 3.069C13.9247 3.753 14.1362 4.5045 14.1362 5.3235C14.1362 6.3045 13.8617 7.1505 13.3127 7.8615C12.7727 8.5725 11.9807 9.063 10.9367 9.333C11.6207 9.45 12.2237 9.6975 12.7457 10.0755C13.2677 10.4445 13.6772 10.9035 13.9742 11.4525C14.2802 12.0015 14.4332 12.609 14.4332 13.275C14.4332 13.842 14.3342 14.4045 14.1362 14.9625C13.9382 15.5205 13.6097 16.029 13.1507 16.488C12.6917 16.947 12.0752 17.316 11.3012 17.595C10.5272 17.865 9.55967 18 8.39867 18H1.72967ZM4.29467 15.759H8.34467C9.51467 15.759 10.3607 15.516 10.8827 15.03C11.4137 14.544 11.6792 13.914 11.6792 13.14C11.6792 12.357 11.4002 11.727 10.8422 11.25C10.2842 10.773 9.45167 10.5345 8.34467 10.5345H4.29467V15.759ZM4.29467 3.015V8.307H8.29067C9.28967 8.307 10.0727 8.0685 10.6397 7.5915C11.2157 7.1145 11.5037 6.453 11.5037 5.607C11.5037 4.806 11.2247 4.176 10.6667 3.717C10.1177 3.249 9.33467 3.015 8.31767 3.015H4.29467Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6768,
    cy: 18.501,
    r: 2.32526,
    fill: "#169EDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingLogo);
export default __webpack_public_path__ + "static/media/booking-logo.8ac6b210626073b847a3f885065f5cd9.svg";
export { ForwardRef as ReactComponent };